<template functional>
  <section>
    <table class="entsys--table summary-details-table">
      <colgroup>
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr class="total-summary">
          <td>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.expense.label",
                "Expense"
              )
            }}
          </td>
          <td class="text-right">
            {{ parent.masterCurrency(props.report.totalExpenseAmountCents) }}
          </td>
        </tr>

        <tr class="total-summary">
          <td>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.income.label",
                "Income"
              )
            }}
          </td>
          <td class="text-right">
            {{
              parent.masterCurrency(0 - props.report.totalRevenueAmountCents)
            }}
          </td>
        </tr>

        <tr class="total-summary">
          <td class="text-left text-sm-right">
            <b>
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.revenueExpenseTotal.label",
                  "Total cost"
                )
              }}</b
            >
          </td>
          <td class="text-right">
            <b>
              {{
                parent.masterCurrency(
                  props.report.totalExpenseAmountCents +
                    (0 - props.report.totalRevenueAmountCents)
                )
              }}</b
            >
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <br />
    <h2 class="text-center text-sm-left">
      {{
        parent.$t(
          "people:ShoppingBasket.Events.PersonEventFinancialReport.payments.title",
          "Payments to organiser"
        )
      }}
    </h2>
    <br />
    <table class="entsys--table summary-details-table">
      <colgroup>
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr class="total-summary">
          <td>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.totalConfirmedPaymentsAmountCents.label",
                "Total payments"
              )
            }}
          </td>
          <td class="text-right">
            {{
              parent.masterCurrency(
                props.report.totalConfirmedPaymentsAmountCents
              )
            }}
          </td>
        </tr>

        <tr class="total-summary">
          <td>
            <b>{{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.totalPayableAmountCents.label",
                "In shopping basket"
              )
            }}</b>
          </td>
          <td class="text-right">
            <b>{{
              parent.masterCurrency(props.report.totalPayableAmountCents)
            }}</b>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <h2 class="text-center text-sm-left">
      {{
        parent.$t(
          "people:ShoppingBasket.Events.PersonEventFinancialReport.payouts.title",
          "Payouts from organiser"
        )
      }}
    </h2>
    <br />
    <table class="entsys--table summary-details-table">
      <colgroup>
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr class="total-summary">
          <td>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.totalPayoutsAmountCents.label",
                "To be returned as refunds"
              )
            }}
          </td>
          <td class="text-right">
            {{
              parent.masterCurrency(0 - props.report.totalPayoutsAmountCents)
            }}
          </td>
        </tr>

        <tr class="total-summary">
          <td>
            <b>
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.totalPendingReturnsAmountCents.label",
                  "To be returned as refunds"
                )
              }}
            </b>
          </td>
          <td class="text-right">
            <b>{{
              parent.masterCurrency(
                0 - props.report.totalPendingReturnsAmountCents
              )
            }}</b>
          </td>
        </tr>

        <tr
          v-for="pending in props.report.pendingManualCreditTransferPayouts"
          :key="pending.id"
          class="total-summary"
        >
          <td>
            <b>
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.pendingManualCreditTransferPayout.label",
                  "Remaining amount to receive from organiser via bank transer"
                )
              }}
              {{ $options.recipientData(pending) }}
            </b>
          </td>
          <td class="text-right">
            <b>{{ parent.masterCurrency(0 - pending.amountCents) }}</b>
          </td>
        </tr>
        <tr class="total-summary">
          <td class="text-left text-sm-right">
            <b>
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.summary.total.label",
                  "Total balance"
                )
              }}</b
            >
          </td>
          <td class="text-right">
            <b>{{ parent.masterCurrency(props.summaryTotals) }}</b>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
export default {
  name: "StatementReportSummary",
  props: {
    report: {
      type: Object,
      required: true
    },
    summaryTotals: {
      type: Number,
      default: 0
    }
  },
  recipientData({ recipientName: name, recipientIban: iban }) {
    if (name || iban) {
      return `(${[name, iban].filter(Boolean).join(", ")})`;
    }
    return "";
  }
};
</script>
<style lang="scss" scoped>
@use "mixin.scss" as c;

.summary-details-table {
  colgroup {
    col:first-child {
      width: 85%;
      @media (max-width: 960px) {
        width: auto;
      }
    }
  }

  tr {
    @include c.mobile-row;
  }
}
</style>
